import actions from '@/core/store/documentos/signatarios/actions'

export default {
	actions,
}
